<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'organizers'" :bannerTitle="bannerTitle" :breadCrumb="borrowSpaceCrumb" />
        <RentalVenueSpaceBody />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/KECC/Common/NavbarStyle'
    import Header from 'components/DefaultHome/KECC/Common/Header'
    import RentalVenueSpaceBody from './RentalVenueSpaceBody'
    import FooterTop from 'components/DefaultHome/KECC/Common/FooterTop?v=1.0'
    import FooterBottom from 'components/DefaultHome/KECC/Common/BacktopButton'

    export default {
        name: 'RentalVenueSpaceMain',
        components: {
            Navbar,
            Header,
            RentalVenueSpaceBody,
            FooterTop,
            FooterBottom
        },
        data() {
            return {
                bannerTitle: "ACTIVITY<br>EXTENSION",
                borrowSpaceCrumb: [{
                        name: this.$t('navbar.menu_2'),
                        path: "/rental-venue"
                    },
                    {
                        name: this.$t('navbar.menu_2_3')
                    }
                ]
            }
        }
    }
</script>
